import { axios } from "@/lib/axios";

export function apiAuthSendCode( params: { userPhone: string; areaCode?: string } ) {
    return axios.post( "/api/front/auth/sendCode", { ...params, areaCode: params.areaCode?.replace( /^\+/, "" ) } );
}

export function apiAuthLogin( params: { userPhone: string; code: string; areaCode: string } ) {
    return axios.post( "/api/front/auth/userLoginNew", { ...params, areaCode: params.areaCode?.replace( /^\+/, "" ) } );
}

export function apiAuthSendEmailCode( params: { userEmail: string } ) {
    return axios.post( "/api/front/auth/sendEmailCode", params );
}

export function apiEmailUserLogin( params: { userEmail: string; code: string } ) {
    return axios.post( "/api/front/auth/emailUserLogin", params );
}

export function apiAuthLogout() {
    return axios.post( "/api/front/auth/logout", {} );
}

// 获取三方登录url
export function apiGetOauthUrl( params: { url: string; source: string } ) {
    return axios.post( "/api/front/sdk/user/oauth/renderAuth", params );
}

// 三方获取数据
export function apiOauthCallback( params: { state: string; source: string } ) {
    const { source, state } = params;
    return axios.post( `/api/front/sdk/user/oauth/${source}/login`, { state } );
}

// 更新用户推送Token
export function apiUpdatePushToken( params: { pushToken: string } ) {
    return axios.post( "/api/front/user/update/pushToken", params );
}
